import * as React from 'react';

import type { RankAdminClient } from '@/api/rank-admin-client';
import { HttpRankAdminClient } from '@/api/rank-admin-client.http';

// =============================================================================
// rank-admin-client-context.tsx — Injection du RankAdminClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S17-bis) : l'adaptateur HTTP RÉEL
// (HttpRankAdminClient) — le câblage front↔back contre le contrat de routes figé D1. Les tests de
// composant injectent le StubRankAdminClient (double déterministe) via le provider. Séparé du
// PositioningClientProvider (fournisseur, indicateur F-10) : l'accès ADMIN au mode Rang est un concern
// DISTINCT (décision GATE_0).

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultRankAdminClient: RankAdminClient = new HttpRankAdminClient();

const RankAdminClientContext = React.createContext<RankAdminClient>(
  defaultRankAdminClient,
);

export interface RankAdminClientProviderProps {
  client?: RankAdminClient | undefined;
  children: React.ReactNode;
}

export function RankAdminClientProvider({
  client = defaultRankAdminClient,
  children,
}: RankAdminClientProviderProps): React.JSX.Element {
  return (
    <RankAdminClientContext.Provider value={client}>
      {children}
    </RankAdminClientContext.Provider>
  );
}

export function useRankAdminClient(): RankAdminClient {
  return React.useContext(RankAdminClientContext);
}
